export const manifest = (() => {
function __memo(fn) {
	let value;
	return () => value ??= (value = fn());
}

return {
	appDir: "_app",
	appPath: "_app",
	assets: new Set(["images/image-placeholder.png","images/person-placeholder.jpg","images/sonja.jpg"]),
	mimeTypes: {".png":"image/png",".jpg":"image/jpeg"},
	_: {
		client: {"start":"_app/immutable/entry/start.fbaCg8VY.js","app":"_app/immutable/entry/app.WTzTpim4.js","imports":["_app/immutable/entry/start.fbaCg8VY.js","_app/immutable/chunks/entry.Qx6UZvYN.js","_app/immutable/chunks/scheduler.11LYO-93.js","_app/immutable/entry/app.WTzTpim4.js","_app/immutable/chunks/preload-helper.0HuHagjb.js","_app/immutable/chunks/scheduler.11LYO-93.js","_app/immutable/chunks/index.v-pHvQc9.js"],"stylesheets":[],"fonts":[],"uses_env_dynamic_public":false},
		nodes: [
			__memo(() => import('./nodes/0.js')),
			__memo(() => import('./nodes/1.js')),
			__memo(() => import('./nodes/2.js')),
			__memo(() => import('./nodes/3.js')),
			__memo(() => import('./nodes/4.js')),
			__memo(() => import('./nodes/5.js')),
			__memo(() => import('./nodes/6.js')),
			__memo(() => import('./nodes/7.js')),
			__memo(() => import('./nodes/8.js')),
			__memo(() => import('./nodes/9.js'))
		],
		routes: [
			{
				id: "/",
				pattern: /^\/$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 2 },
				endpoint: null
			},
			{
				id: "/api/counter",
				pattern: /^\/api\/counter\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/counter/_server.js'))
			},
			{
				id: "/api/create-friend",
				pattern: /^\/api\/create-friend\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/create-friend/_server.js'))
			},
			{
				id: "/api/create-post",
				pattern: /^\/api\/create-post\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/create-post/_server.js'))
			},
			{
				id: "/api/delete-friend",
				pattern: /^\/api\/delete-friend\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/delete-friend/_server.js'))
			},
			{
				id: "/api/delete-post",
				pattern: /^\/api\/delete-post\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/delete-post/_server.js'))
			},
			{
				id: "/api/save-page",
				pattern: /^\/api\/save-page\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/save-page/_server.js'))
			},
			{
				id: "/api/search-friends",
				pattern: /^\/api\/search-friends\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/search-friends/_server.js'))
			},
			{
				id: "/api/update-friend",
				pattern: /^\/api\/update-friend\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/update-friend/_server.js'))
			},
			{
				id: "/api/update-post",
				pattern: /^\/api\/update-post\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/update-post/_server.js'))
			},
			{
				id: "/api/upload-asset",
				pattern: /^\/api\/upload-asset\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/upload-asset/_server.js'))
			},
			{
				id: "/assets/[...path]",
				pattern: /^\/assets(?:\/(.*))?\/?$/,
				params: [{"name":"path","optional":false,"rest":true,"chained":true}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/assets/_...path_/_server.js'))
			},
			{
				id: "/feed.xml",
				pattern: /^\/feed\.xml\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/feed.xml/_server.js'))
			},
			{
				id: "/friends",
				pattern: /^\/friends\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 3 },
				endpoint: null
			},
			{
				id: "/friends/new",
				pattern: /^\/friends\/new\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 4 },
				endpoint: null
			},
			{
				id: "/friends/[id]",
				pattern: /^\/friends\/([^/]+?)\/?$/,
				params: [{"name":"id","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,], errors: [1,], leaf: 5 },
				endpoint: null
			},
			{
				id: "/login",
				pattern: /^\/login\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 6 },
				endpoint: null
			},
			{
				id: "/logout",
				pattern: /^\/logout\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 7 },
				endpoint: null
			},
			{
				id: "/posts/new",
				pattern: /^\/posts\/new\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 8 },
				endpoint: null
			},
			{
				id: "/posts/[slug]",
				pattern: /^\/posts\/([^/]+?)\/?$/,
				params: [{"name":"slug","optional":false,"rest":false,"chained":false}],
				page: { layouts: [0,], errors: [1,], leaf: 9 },
				endpoint: null
			},
			{
				id: "/sitemap.xml",
				pattern: /^\/sitemap\.xml\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/sitemap.xml/_server.js'))
			}
		],
		matchers: async () => {
			
			return {  };
		},
		server_assets: {}
	}
}
})();

export const prerendered = new Set([]);

export const base = "";